import {
  adminJobActionSchema,
  alertFrequencySchema,
  applicationStatusSchema,
  changePasswordSchema,
  contactDetailsSchema,
  createApplicationSchema,
  createJobAlertSchema,
  createJobSchema,
  currencySchema,
  educationSchema,
  emailSchema,
  employerProfileSchema,
  forgotPasswordSchema,
  jobPreferencesSchema,
  jobSearchSchema,
  locationTypeSchema,
  loginSchema,
  paginationSchema,
  passwordSchema,
  presignedUrlRequestSchema,
  registerSchema,
  resetPasswordSchema,
  salaryRangeSchema,
  seekerProfileSchema,
  sendMessageSchema,
  updateApplicationStatusSchema,
  updateEmployerProfileSchema,
  updateJobAlertSchema,
  updateJobSchema,
  updateSeekerProfileSchema,
  updateUserStatusSchema,
  userRoleSchema,
  verifyEmployerSchema,
  workExperienceSchema
} from "./chunk-3X43X5IH.mjs";
import "./chunk-WBQAMGXK.mjs";

// src/index.ts
var INDUSTRIES = [
  "Technology",
  "Healthcare",
  "Finance",
  "Education",
  "Manufacturing",
  "Retail",
  "Hospitality",
  "Real Estate",
  "Media & Entertainment",
  "Consulting",
  "Legal",
  "Non-Profit",
  "Government",
  "Energy",
  "Transportation",
  "Agriculture",
  "Construction",
  "Other"
];
var COMPANY_SIZES = [
  "1-10 employees",
  "11-50 employees",
  "51-200 employees",
  "201-500 employees",
  "501-1000 employees",
  "1001-5000 employees",
  "5000+ employees"
];
var JOB_TYPES = [
  "Full-time",
  "Part-time",
  "Contract",
  "Temporary",
  "Internship",
  "Freelance"
];
var EXPERIENCE_LEVELS = [
  "Entry Level",
  "Junior",
  "Mid-Level",
  "Senior",
  "Lead",
  "Manager",
  "Director",
  "Executive"
];
var SKILLS_SUGGESTIONS = [
  // Technical
  "JavaScript",
  "TypeScript",
  "Python",
  "Java",
  "C++",
  "Go",
  "Rust",
  "React",
  "Vue.js",
  "Angular",
  "Node.js",
  "Express",
  "Django",
  "FastAPI",
  "Spring Boot",
  "AWS",
  "Azure",
  "GCP",
  "Docker",
  "Kubernetes",
  "PostgreSQL",
  "MongoDB",
  "Redis",
  "GraphQL",
  "REST APIs",
  "CI/CD",
  "Git",
  "Linux",
  // Soft Skills
  "Communication",
  "Leadership",
  "Problem Solving",
  "Team Collaboration",
  "Project Management",
  "Agile/Scrum",
  "Critical Thinking",
  "Time Management",
  "Adaptability",
  "Creativity"
];
function formatSalary(min, max, currency, period) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0
  });
  const periodLabel = period === "yearly" ? "/yr" : period === "monthly" ? "/mo" : "/hr";
  return `${formatter.format(min)} - ${formatter.format(max)}${periodLabel}`;
}
function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}
function formatRelativeTime(dateString) {
  const date = new Date(dateString);
  const now = /* @__PURE__ */ new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffDays = Math.floor(diffMs / (1e3 * 60 * 60 * 24));
  if (diffDays === 0) {
    const diffHours = Math.floor(diffMs / (1e3 * 60 * 60));
    if (diffHours === 0) {
      const diffMinutes = Math.floor(diffMs / (1e3 * 60));
      return diffMinutes <= 1 ? "Just now" : `${diffMinutes} minutes ago`;
    }
    return diffHours === 1 ? "1 hour ago" : `${diffHours} hours ago`;
  }
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return `${diffDays} days ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
  if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`;
  return `${Math.floor(diffDays / 365)} years ago`;
}
function generateSlug(text) {
  return text.toLowerCase().replace(/[^\w\s-]/g, "").replace(/\s+/g, "-").replace(/--+/g, "-").trim();
}
function truncateText(text, maxLength) {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength - 3) + "...";
}
export {
  COMPANY_SIZES,
  EXPERIENCE_LEVELS,
  INDUSTRIES,
  JOB_TYPES,
  SKILLS_SUGGESTIONS,
  adminJobActionSchema,
  alertFrequencySchema,
  applicationStatusSchema,
  changePasswordSchema,
  contactDetailsSchema,
  createApplicationSchema,
  createJobAlertSchema,
  createJobSchema,
  currencySchema,
  educationSchema,
  emailSchema,
  employerProfileSchema,
  forgotPasswordSchema,
  formatDate,
  formatRelativeTime,
  formatSalary,
  generateSlug,
  jobPreferencesSchema,
  jobSearchSchema,
  locationTypeSchema,
  loginSchema,
  paginationSchema,
  passwordSchema,
  presignedUrlRequestSchema,
  registerSchema,
  resetPasswordSchema,
  salaryRangeSchema,
  seekerProfileSchema,
  sendMessageSchema,
  truncateText,
  updateApplicationStatusSchema,
  updateEmployerProfileSchema,
  updateJobAlertSchema,
  updateJobSchema,
  updateSeekerProfileSchema,
  updateUserStatusSchema,
  userRoleSchema,
  verifyEmployerSchema,
  workExperienceSchema
};
